
import { Component, Vue, Prop } from "vue-property-decorator";
import { UserModule } from "../../../store/modules/user";
import { getTagList } from "@/api/other";
import { handleTags } from "@/api/order";

@Component({
  name: "department",
})
export default class extends Vue {
  // 接受父组件的值
  @Prop({
    type: String,
    default: "",
  })
  companyId!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  tagVisible!: Boolean;

  @Prop({
    type: Array,
    default: () => [],
  })
  selectedTags!: [];

  @Prop({
    type: Object,
    default: () => ({}),
  })
  orderDetail!: {};
  // 1 报修 2 添加 3 订单处理 4 任务处理 5任务搜索
  @Prop({
    type: Number,
    default: 0,
  })
  enterType!: Number;

  private tagFirstListOptions: any = [];
  created() {
    this.gettagList();
  }

  private gettagList() {
    var parameters: any = {};
    parameters.user_id = UserModule.getUserId;
    parameters.company_id = this.companyId;

    getTagList(parameters)
      .then((res) => {
        if (res.data) {
          this.tagFirstListOptions = res.data.list;
        } else {
          this.tagFirstListOptions = [];
        }
      })
      .catch((error) => {
        let msg = error.msg;
      });
  }
  private change() {
    this.$set(this.form, "second", "");
  }
  private confirm() {
    if (!this.form || !this.form.second || !this.form.second.tags_id) {
      this.$notify({
        title: "提示",
        message: "请选择二级标签",
        offset: 100,
        type: "error",
      });
      return;
    }
    let tagBean: any = this.form.second;
    switch (this.enterType) {
      case 1:
      case 2:
      case 5:
        this.$emit("confirm", this.form.second);
        this.$emit("close", false);
        break;
      case 3:
        // 东改 去重
        if (this.selectedTags) {
          let filter = this.selectedTags.filter((tag: any) => {
            return tag.tags_id === tagBean.tags_id;
          });
          if (filter && filter.length > 0) {
            this.showErrorMsg("此标签已添加过");
          } else {
            this.addTags(tagBean);
          }
        } else {
          this.addTags(tagBean);
        }
        break;
      case 4:
        // 东改 去重
        if (this.selectedTags) {
          let filter = this.selectedTags.filter((tag: any) => {
            return tag.tags_id === tagBean.tags_id;
          });
          if (filter && filter.length > 0) {
            this.showErrorMsg("此标签已添加过");
          } else {
            this.addTags(tagBean);
          }
        } else {
          this.addTags(tagBean);
        }
        break;
    }
  }
  private close() {
    this.$emit("close", false);
  }

  private listData = [];
  private form: any = {
    first: {},
    second: {},
  };

  // 东改 添加标签 request

  private addTags(tagBean: any) {
    let tags: any = [];
    if (this.selectedTags) {
      tags = tags.concat(this.selectedTags);
    }
    tags.push(tagBean);
    let values: any = [];
    for (const item of tags) {
      let tag: any = {};
      tag.tags_name = item.tags_name;
      tag.tags_id = item.tags_id;
      values.push(tag);
    }
    const params: any = {
      user_id: UserModule.getUserId,
      company_id: this.companyId,
      order_id: (this.orderDetail as any).order.id,
      tags: JSON.stringify(values),
    };
    if ((this.orderDetail as any).order_service) {
      params.order_service_id = (this.orderDetail as any).order_service.id;
    }
    if ((this.orderDetail as any).order_task) {
      params.order_task_id = (this.orderDetail as any).order_task.id;
    }
    handleTags(params)
      .then((res: any) => {
        this.$emit("confirm", tagBean);
        this.$emit("close", false);
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(err.msg);
      });
  }

  // hud
  private showErrorMsg(msg: string) {
    this.$notify({
      title: "提示",
      message: msg,
      offset: 100,
      type: "error",
    });
  }
}
